module.exports = __webpack_public_path__ + "img/electric_skateboard.c0d930d5.png";